import { ObjectId } from "../driver/mongodb/typings"

export type EntityId = string | number | Date | ObjectId
